export interface TenantConfig {
  applicationName: string;
  frontUrl: string;
  checkoutUrl: string;
  checkoutUrlV2: string;
  logoUrl: string;
}

const DEFAULT_CONFIG: TenantConfig = {
  applicationName: import.meta.env.VITE_APPLICATION_NAME || "barte",
  frontUrl: import.meta.env.VITE_FRONT_URL || "https://app.barte.com/",
  checkoutUrl: import.meta.env.VITE_CHECKOUT_URL || "https://checkout.barte.com/",
  checkoutUrlV2: import.meta.env.VITE_CHECKOUT_URL_CHECKOUTV2 || "https://pay.barte.com/",
  logoUrl: `/images/logo/logo-${import.meta.env.VITE_APPLICATION_NAME || "barte"}.svg`,
};

let currentConfig: TenantConfig = DEFAULT_CONFIG;

export async function loadTenantConfig(): Promise<TenantConfig> {
  try {
    const response = await fetch("/tenants.json");
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const tenants: Record<string, TenantConfig> = await response.json();
    const hostname = window.location.hostname;
    currentConfig = tenants[hostname] || DEFAULT_CONFIG;
  } catch {
    currentConfig = DEFAULT_CONFIG;
  }
  return currentConfig;
}

export function getTenantConfig(): TenantConfig {
  return currentConfig;
}
